import { render, staticRenderFns } from "./FclListIntra.vue?vue&type=template&id=f8844c52&scoped=true"
import script from "./FclListIntra.vue?vue&type=script&lang=js"
export * from "./FclListIntra.vue?vue&type=script&lang=js"
import style0 from "./FclListIntra.vue?vue&type=style&index=0&id=f8844c52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8844c52",
  null
  
)

export default component.exports